import React from 'react';
import PropTypes from 'prop-types';

import Input from '@material-ui/core/Input';
import SearchIcon from '@material-ui/icons/Search';

import './Search.scss';

const Search = ({
  placeholder,
  searchQuery,
  setSearchQuery,
}) => (
  <div className="search">
    <SearchIcon />
    <Input
      className="search__input"
      placeholder={placeholder}
      value={searchQuery}
      onChange={setSearchQuery}
    />
  </div>
);

Search.propTypes = {
  placeholder: PropTypes.string,
  searchQuery: PropTypes.string.isRequired,
  setSearchQuery: PropTypes.func.isRequired,
};

Search.defaultProps = {
  placeholder: '',
};

export default Search;



// WEBPACK FOOTER //
// ./src/common/components/Search/Search.js